import _objectSpread from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import $1DoQa$intlmessageformat from "intl-messageformat";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
    * Copyright 2020 Adobe. All rights reserved.
    * This file is licensed to you under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License. You may obtain a copy
    * of the License at http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software distributed under
    * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
    * OF ANY KIND, either express or implied. See the License for the specific language
    * governing permissions and limitations under the License.
    */
var $d6fd23bc337660df$export$64839e615120df17 = /*#__PURE__*/function () {
  _createClass($d6fd23bc337660df$export$64839e615120df17, [{
    key: "getStringForLocale",
    value: function getStringForLocale(key, locale) {
      var strings = this.messages[locale];
      if (!strings) {
        strings = $d6fd23bc337660df$var$getStringsForLocale(locale, this.messages, this.defaultLocale);
        this.messages[locale] = strings;
      }
      var string = strings[key];
      if (!string) throw new Error("Could not find intl message ".concat(key, " in ").concat(locale, " locale"));
      return string;
    }
  }]);
  function $d6fd23bc337660df$export$64839e615120df17(messages) {
    var defaultLocale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en-US";
    _classCallCheck(this, $d6fd23bc337660df$export$64839e615120df17);
    // Clone messages so we don't modify the original object.
    this.messages = _objectSpread({}, messages);
    this.defaultLocale = defaultLocale;
  }
  return $d6fd23bc337660df$export$64839e615120df17;
}();
function $d6fd23bc337660df$var$getStringsForLocale(locale, strings) {
  var defaultLocale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "en-US";
  // If there is an exact match, use it.
  if (strings[locale]) return strings[locale];
  // Attempt to find the closest match by language.
  // For example, if the locale is fr-CA (French Canadian), but there is only
  // an fr-FR (France) set of strings, use that.
  // This could be replaced with Intl.LocaleMatcher once it is supported.
  // https://github.com/tc39/proposal-intl-localematcher
  var language = $d6fd23bc337660df$var$getLanguage(locale);
  if (strings[language]) return strings[language];
  for (var key in strings) {
    if (key.startsWith(language + "-")) return strings[key];
  }
  // Nothing close, use english.
  return strings[defaultLocale];
}
function $d6fd23bc337660df$var$getLanguage(locale) {
  // @ts-ignore
  if (Intl.Locale)
    // @ts-ignore
    return new Intl.Locale(locale).language;
  return locale.split("-")[0];
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
var $972eb555d604f491$export$526ebc05ff964723 = /*#__PURE__*/function () {
  _createClass($972eb555d604f491$export$526ebc05ff964723, [{
    key: "format",
    value: function format(key, variables) {
      var message = this.cache[key];
      if (!message) {
        var msg = this.messages.getStringForLocale(key, this.locale);
        if (!msg) throw new Error("Could not find intl message ".concat(key, " in ").concat(this.locale, " locale"));
        message = new (0, $1DoQa$intlmessageformat)(msg, this.locale);
        this.cache[key] = message;
      }
      var varCopy;
      if (variables) varCopy = Object.keys(variables).reduce(function (acc, key) {
        acc[key] = variables[key] == null ? false : variables[key];
        return acc;
      }, {});
      return message.format(varCopy);
    }
  }]);
  function $972eb555d604f491$export$526ebc05ff964723(locale, messages) {
    _classCallCheck(this, $972eb555d604f491$export$526ebc05ff964723);
    this.locale = locale;
    this.messages = messages;
    this.cache = {};
  }
  return $972eb555d604f491$export$526ebc05ff964723;
}();
export { $d6fd23bc337660df$export$64839e615120df17 as MessageDictionary, $972eb555d604f491$export$526ebc05ff964723 as MessageFormatter };